import { useState } from "react";

import { generatePath, useHistory, useParams } from "react-router-dom";

import { deleteSearch } from "@/api/endpoints/searches";
import { postTrackingData } from "@/api/endpoints/track";
import ConfirmModal from "@/containers/ConfirmModal";
import { ROUTES } from "@/routes_new";
import { EVENT } from "@/tracking_events";
import Button from "@components/Button";
import Typography from "@components/Typography";

const Remove = () => {
  const history = useHistory();
  const { uuid, orgUuid } = useParams();

  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);

  const redirectAndReload = () => {
    history.replace(generatePath(ROUTES.MENTION_LIST_ORGID, { orgUuid }));
    window.location.reload();
  };

  const onHide = () => setShowConfirmDeleteModal(false);

  const openConfirmModal = () => {
    setShowConfirmDeleteModal(true);
  };

  const onDelete = () => {
    deleteSearch(uuid)
      .then((response) => {
        if (response.ok) {
          postTrackingData(EVENT.DELETE_ALERT, { uuid });
          redirectAndReload();
        }
      })
      .catch((error) => {
        throw error;
      });
  };

  return (
    <>
      <div className="mt-3">
        <Typography variant="h4">{L.MENTION_SETTING_REMOVE}</Typography>
        <Typography>{L.MENTIONS_VIEW_CONFIRM_DELETE_SEARCH}</Typography>
        <Button
          data-testid="remove-alert-button"
          onClick={openConfirmModal}
          variant="secondary"
        >
          {L.MENTION_SETTING_REMOVE}
        </Button>
      </div>
      <ConfirmModal
        onCancel={onHide}
        show={showConfirmDeleteModal}
        onConfirm={onDelete}
        title={L.MENTION_SETTING_REMOVE}
        message={L.MENTIONS_VIEW_CONFIRM_DELETE_SEARCH}
        dangerous={true}
      />
    </>
  );
};

export default Remove;
